/**
 * Converts breadcrumb items to JSON-LD BreadcrumbList schema
 * Used for SEO - helps search engines understand site structure
 * @param {Array} breadcrumbItems - Array of breadcrumb objects with label and to properties
 * @returns {Object} JSON-LD BreadcrumbList schema
 */
export const getBreadcrumbSchema = (breadcrumbItems) => {
  if (!Array.isArray(breadcrumbItems) || breadcrumbItems.length === 0) {
    return null;
  }

  const baseUrl = "https://blackroth.in";

  const itemListElement = breadcrumbItems.map((item, index) => ({
    "@type": "ListItem",
    "position": index + 1,
    "name": item.label,
    "item": `${baseUrl}${item.to || "/"}`
  }));

  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": itemListElement
  };
};
